import Phaser from 'phaser';
export default Phaser;